import React, { useEffect, useState } from 'react';
import './disponibilidad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCalendarAlt, faLayerGroup, faExclamationTriangle, faTrashAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAuthServices } from '../../../services/useFetch';
import { Paginador } from '../../Paginacion/Paginador';

export const Disponibilidad = ({ profesionalSeleccionado }) => {

    const { requestPost } = useAuthServices();

    const [disponibilidadList, setDisponibilidadList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    const [executeConsulta, setExecuteConsulta] = useState(false);
    const [paginacion, setPaginacion] = useState({
        totalElementos: '0',
        elementosPorPagina: '6',
        paginaActual: '1'
    });

    useEffect(() => {
        obtieneDisponibilidadService();
    }, []);

    const obtieneDisponibilidadService = async () => {
        setLoading(true);
        if (!!profesionalSeleccionado) {
            const body = {
                idUsuario: profesionalSeleccionado.id
            };
            const response = await requestPost(body, 13);
            if (!response.error) {
                const { estado, objeto } = response.data;
                if (estado) {
                    setDisponibilidadList(objeto || []);
                    setPaginacion(prev => ({
                        ...prev,
                        totalElementos: (objeto || []).length.toString()
                    }));
                }
            }
        }
        setLoading(false);
    };

    const eliminaDisponibilidadService = async () => {
        if (!idToDelete) return;
        const body = { id: idToDelete };
        const response = await requestPost(body, 14);
        if (!response.error) {
            const { estado } = response.data;
            if (estado) {
                obtieneDisponibilidadService();
                handleCloseConfirm();
            }
        }
    };

    const handleOpenConfirm = (id) => {
        setIdToDelete(id);
        setModalConfirm(true);
    };

    const handleCloseConfirm = () => {
        setModalConfirm(false);
        setIdToDelete(null);
    };

    const getPaginatedDisponibilidad = () => {
        const indexPage = (parseInt(paginacion.paginaActual, 10) - 1) * parseInt(paginacion.elementosPorPagina, 10);
        const limitPage = indexPage + parseInt(paginacion.elementosPorPagina, 10);
        return (disponibilidadList || []).slice(indexPage, limitPage);
    };

    const getCardType = (fechaInicio, fechaFin) => {

        const parseDate = (dateStr) => {
            const [day, month, year] = dateStr.split('/');
            return new Date(year, month - 1, day);
        };

        const today = new Date();

        const start = parseDate(fechaInicio);
        start.setHours(0, 0, 0, 0);

        const end = parseDate(fechaFin);
        end.setHours(23, 59, 59, 999);

        if (today >= start && today <= end) return 'ACTUAL';
        if (start > today) return 'FUTURO';

        return 'DEFAULT';
    };

    const getCardStyle = (type) => {
        switch (type) {
            case 'ACTUAL': return 'card-disponibilidad-current';
            case 'FUTURO': return 'card-disponibilidad-future';
            case 'DEFAULT': return 'card-disponibilidad-default';
            default: return '';
        }
    };

    const getHeaderLabel = (type) => {
        switch (type) {
            case 'ACTUAL': return 'Periodo Activo';
            case 'FUTURO': return 'Periodo Futuro';
            case 'DEFAULT': return 'Periodo por Defecto';
            default: return 'Periodo';
        }
    };

    return (
        <div className="container-disponibilidad">
            <div className="row mb-4">
                <div className="col-12">
                    <h4 className="mb-2">Bloques de disponibilidad</h4>
                    <div className="alert alert-light border shadow-sm p-3 mt-3 mb-0" role="alert">
                        <div className="d-flex align-items-center mb-2">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="text-warning me-2" />
                            <strong style={{ fontSize: '0.9rem', color: '#1C1D25' }}>¿Cómo funciona tu disponibilidad?</strong>
                        </div>
                        <p className="mb-2" style={{ fontSize: '0.85rem', color: '#1C1D25', lineHeight: '1.5' }}>
                            El sistema prioriza tus <strong>horarios activos de hoy</strong>. Si no hay, te muestra los próximos.
                        </p>
                        <p className="mb-0" style={{ fontSize: '0.85rem', color: '#1C1D25', lineHeight: '1.5' }}>
                            ¿No tienes nada configurado? Tranquilo, activamos un <strong>horario por defecto</strong> para que siempre puedan agendarte.
                        </p>
                    </div>
                </div>
            </div>
            {loading ? (
                <div className="d-flex justify-content-center my-0">
                    <div className="spinner-border text-primary" role="status" style={{ color: 'orange' }}>
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                </div>
            ) : disponibilidadList.length > 0 ? (
                <div className="row">
                    {getPaginatedDisponibilidad().map((item, index) => {
                        const type = getCardType(item.fechaInicio, item.fechaFin);
                        return (
                            <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                                <div className={`card-disponibilidad ${getCardStyle(type)} animate__animated animate__fadeInUp`} style={{ animationDelay: `${index * 0.1}s` }}>
                                    <div className="card-disponibilidad-header">
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <div className="d-flex align-items-center">
                                                <FontAwesomeIcon icon={faCalendarAlt} className="icon-header me-2" />
                                                <span>{getHeaderLabel(type)}</span>
                                            </div>
                                            {item.id !== 0 && (
                                                <div className="btn-delete-disponibilidad" title="Eliminar bloque" onClick={() => handleOpenConfirm(item.id)}>
                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-disponibilidad-body">
                                        <div className="dato-disponibilidad">
                                            <div className="dato-label-container">
                                                <p className="dato-label">Desde</p>
                                                <span className="dato-valor">{item.fechaInicio}</span>
                                            </div>
                                            <div className="dato-label-container">
                                                <p className="dato-label">Hasta</p>
                                                <span className="dato-valor">{item.fechaFin}</span>
                                            </div>
                                        </div>

                                        <hr className="hr-disponibilidad" />

                                        <div className="info-bottom-disponibilidad">
                                            <div className="flex-grow-1">
                                                <div className="dato-label-small mb-1">
                                                    <FontAwesomeIcon icon={faClock} className="me-1 text-primary" /> Rango Horario
                                                </div>
                                                <div className="dato-valor-medium">
                                                    {item.horaInicio} <FontAwesomeIcon icon={faArrowRight} className="mx-1 text-mutedSmall" style={{ fontSize: '0.8rem' }} /> {item.horaFin}
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <div className="dato-label-small mb-1">
                                                    <FontAwesomeIcon icon={faLayerGroup} className="me-1 text-primary" /> Cada
                                                </div>
                                                <div className="dato-valor-medium">{item.intervalo}</div>
                                            </div>
                                        </div>
                                        <div className="mt-3 d-flex align-items-center gap-2">
                                            <div className="status-indicator"></div>
                                            <span style={{ fontSize: '0.75rem', fontWeight: '600' }} className="text-status">
                                                {type === 'DEFAULT' ? 'Configuración sugerida' : 'Disponible para agendar'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="div-container-no-data-agenda">
                    <div className="text-center p-5">
                        <FontAwesomeIcon icon={faExclamationTriangle} size="4x" className="text-warning mb-3" />
                        <h5 className="fw-bold">Sin bloques registrados</h5>
                        <p className="p-label-form">Aún no has definido tu disponibilidad horaria en el sistema.</p>
                        <p className="p-label-form mt-2">Usa la opción <span className="p-bold">"Definir disponibilidad"</span> en el menú superior para comenzar.</p>
                    </div>
                </div>
            )}
            <Paginador
                elementsPaginacion={paginacion}
                setElementsPaginacion={setPaginacion}
                setExecuteConsulta={setExecuteConsulta}
                executeConsulta={executeConsulta}
            />
            <Modal isOpen={modalConfirm} toggle={handleCloseConfirm} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseConfirm}>
                    <h4>Confirmar eliminación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' style={{ color: 'orange' }} /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p className="mt-2">¿Estás completamente seguro de que deseas eliminar este bloque de disponibilidad?</p>
                    <p className="text-muted mt-2" style={{ fontSize: '0.9rem' }}>
                        Al hacerlo, los clientes ya no podrán visualizar estos horarios para el agendamiento automático. Esta acción no afectará a las citas ya programadas.
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" className="text-decoration-none text-muted" onClick={handleCloseConfirm}>Cancelar</Button>
                    <Button color="danger" className="px-4" onClick={eliminaDisponibilidadService}>Eliminar permanentemente</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};
